module.exports = __webpack_public_path__ + "static/media/team--kayla.9baf3ccd.jpg";